<template>
  <div class="problem-hints-edition">
    <div v-html="$t('message.CUSTOM_PROBLEM_HINTS_EXPLANATION')" class="field-hint" />
    <EditableLabelRadio
      :value="problemSheet"
      :items="sheetEditionItems"
      :legend="`${$t('message.DISPLAY_PROBLEM_HINT_SHEET')}${$t('message.TWO_DOTS')}`"
      @input="$emit('problemSheetUpdated', $event)"
    />

    <div v-html="$t('message.CUSTOM_PROBLEM_HINTS_HOWTO')" class="how-to field-hint" />
    <div v-for="(field, index) in hintFields" :key="field.key" class="field-hint-row">
      <div v-if="index !== 0" class="sep" />
      <EditableLabel
        :value="hints[field.key]"
        :legend="`${$t(`message.${field.trad}`)}${$t('message.TWO_DOTS')}`"
        use-textarea
        @input="hintUpdated(field.key, $event)"
      />
      <div class="field-hint semibold">
        {{ `${$t('message.DEFAULT_HINTS')}${$t('message.TWO_DOTS')}` }}
      </div>
      <div v-html="$t(field.help)" class="field-hint" />
    </div>

    <div class="sep" />
    <div class="legend">{{ `${$t('message.IMPACT')}${$t('message.TWO_DOTS')}` }}</div>
    <ImpactHintsEdition :hints="hints.impact || []" @hintsUpdated="hintUpdated('impact', $event)" />
  </div>
</template>

<script>
/**
 * Customizable fields for editing hints of problems 5W1H.
 *
 * @vue-prop {Object} hints - Hints to customize : { lWhat: '', lWho: '', ... }
 * @vue-prop {Number} problemSheet - 0, 1 or 2.
 *                                   0 : Hints shouldn't be displayed in the problem sheet
 *                                   1 : The hints should be displayed in the problem sheet
 *                                   2 : Do what the company decided
 * @vue-prop {Boolean} companySettingsChoice - If true, add the choice to 'use company setting'
 *
 * @vue-event {Object} hintsUpdated - hints value has been updated
 * @vue-event {Object} problemSheetUpdated - problemSheet value has been updated
 */

// Components
import EditableLabel from '@/components/editable-label.vue';
import EditableLabelRadio from '@/components/editable-label-radio.vue';
import ImpactHintsEdition from '@/components/impact-hints-edition.vue';
// Utils
import { DEFAULT_5W1H_HINTS } from '@/utils/constants';


export default {

  name: 'ProblemHintsEdition',

  components: {
    EditableLabel,
    EditableLabelRadio,
    ImpactHintsEdition,
  },

  props: {
    hints: {
      type: Object,
      required: true,
    },
    problemSheet: {
      type: Number,
      required: true,
    },
    companySettingsChoice: Boolean,
  },

  data() {
    return {
      hintFields: DEFAULT_5W1H_HINTS,
    };
  },

  computed: {
    /** Array: Items to pick from in the EditableLabelRadio */
    sheetEditionItems() {
      const items = [
        { id: 0, label: this.$t('message.DONT_DISPLAY') },
        { id: 1, label: this.$t('message.DISPLAY') },
      ];
      if (this.companySettingsChoice) {
        items.push({ id: 2, label: this.$t('message.USE_COMPANY_SETTING') });
      }
      return items;
    },
  },

  methods: {

    /** Update one of the 5W1H hint */
    hintUpdated(key, hint) {
      const val = Object.assign({}, this.hints);
      val[key] = hint;
      this.$emit('hintsUpdated', val);
    },
  },

};
</script>

<style lang="scss">
.problem-hints-edition {
  .how-to {
    margin: 1em 0 0.5em 0;
  }
}
</style>
